import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axios';

const initialState = {
	reviews: { loading: false, reviewList: null, total: 0 },
};

export const getAllReviewsByCriteria = createAsyncThunk(
	'reviews/getAllReviewsByCriteria',
	async (data) => {
		try {
			const response = await axiosInstance.patch(`/review/filter/paged`, data);
			return { list: response.data.content, total: response.data.totalElements };
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response.data.message,
				/* data: error.response.data, */
			};
			throw customError;
		}
	},
);

export const logsSlice = createSlice({
	name: 'reviews',
	initialState,
	reducers: {},
	extraReducers: {
		[getAllReviewsByCriteria.pending]: (state) => {
			state.reviews.loading = true;
		},
		[getAllReviewsByCriteria.rejected]: (state) => {
			state.reviews.loading = false;
		},
		[getAllReviewsByCriteria.fulfilled]: (state, action) => {
			state.reviews.loading = false;
			state.reviews.reviewList = action.payload.list;
			state.reviews.total = action.payload.total;
		},
	},
});

export default logsSlice.reducer;
